import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
import { roleColumns } from './_columns'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import {
  QueryRequestProvider,
  useQueryRequest,
} from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'




const SearchIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    style={{
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#6B7280',
    }}
  >
    <circle cx='11' cy='11' r='8' />
    <line x1='21' y1='21' x2='16.65' y2='16.65' />
  </svg>
)





const QualityList = () => {










  const [searchQuery, setSearchQuery] = useState('')
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }
  // Reset search when component unmounts
  useEffect(() => {
    return () => {
      const tableRows = document.querySelectorAll(
        'table tbody tr'
      ) as NodeListOf<HTMLTableRowElement>
      tableRows.forEach((row: HTMLTableRowElement) => {
        row.style.display = ''
      })
    }
  }, [])


  const { selectedLabel }: any = useListView()
  const { data } = useQuery(
    `clients/101212/categories`,
    () => getUserById('', 'clients/101212/categories'),
    {
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )
  const { updateState } = useQueryRequest()

  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = []
      data.map((eachData) => {
        return dropdownData.push({ label: eachData.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0].value}/price?structureId=`,
        ...initialQueryState,
      })
    }
  }, [data])

  const searchElements = [
    {
      type: 'select',
      queryType: 'price',
      value: 'select',
      options: categoriesList,
    },
  ]

  return (
    <KTCard>
      <div
        style={{
          position: 'relative',
          width: '300px',
          marginLeft: '30px',
          marginTop: '20px',
        }}
      >
        <SearchIcon />
        <input
          type='text'
          placeholder='Search'
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: '100%',
            height: '40px',
            padding: '8px 8px 8px 35px',
            fontSize: '14px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: 'white',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
          onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
        />
      </div>
      <UsersListHeader
        secondLabel={false}
        searchElements={searchElements}
        label='Add new'
        placeholder='Search'
      />
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName={selectedLabel ? 'PricingModalFormTemplate' : 'PricingModalForm'} />
      {/* <UserEditModal formName={'PricingModalForm'} /> */}
    </KTCard>
  )
}

const PricingWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { PricingWrapper }
